import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import rules from '@/utils/rules'

// const SummerSelection = () => import('@/components/Summer/CampClassSelect.vue')
// const EnrollSummer = () => import('@/components/Summer/EnrollmentSummer.vue')

const EnrollmentOther = () => import('@/components/Special/EnrollmentOther.vue')
const Funnel = () => import('@/components/AssistedFunnel/Funnel.vue')
const PaymentConfirmation = () => import('@/components/PaymentConfirmation.vue')
const SummerPaymentConfirmation = () =>
  import('@/components/Summer/SummerPaymentConfirmation.vue')
// const Wait = () => import('@/components/Wait.vue')
// const BlackFridayWait = () => import('@/components/Special/BlackFridayWait.vue')
const Confirmation = () => import('@/components/Main/Confirmation.vue')
const Placement = () => import('@/components/Placement/Placement.vue')
const NonceCheck = () => import('@/components/AssistedFunnel/NonceCheck.vue')

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  { name: 'Funnel', path: '/start', component: Funnel },
  {
    name: 'Nonce Check',
    path: '/start/:nonce',
    component: NonceCheck,
    props: { enrollType: 'ASSISTED_FUNNEL' as EnrollType },
  },
  {
    name: 'Main Nonce Check',
    path: '/join/:nonce',
    component: NonceCheck,
    props: { enrollType: 'MAIN' as EnrollType },
  },
  {
    name: 'Confirmation',
    path: '/confirmation',
    component: Confirmation,
    props: (route) => ({
      nonce: route.query.nonce,
    }),
  }, // main enrollment confirmation page
  {
    name: 'IntroClass',
    path: '/intro-class',
    component: EnrollmentOther,
    // component: BlackFridayWait,
    props: {
      successRoute: 'intro_success',
      title: '90 Minute Intro Class',
    },
    children: [
      {
        path: '',
        // must set props for each named route individually
        props: {
          step1: {
            gtag: 'free_intro',
            enrollType: 'free_intro',
            rulesFromProps: [rules.maxAge.bind(19), rules.minAge.bind(8)],
          },
          step2: { gtag: 'free_intro', enrollType: 'free_intro' },
          // step3: { gtag: 'free_intro' },
        },
        components: {
          step1: () => import('@/components/Summer/Steps/Student.vue'),
          step2: () => import('@/components/Special/ClassForm.vue'),
          step3: () => import('@/components/Special/PaymentForm.vue'),
        },
      },
    ],
  },
  {
    path: '/join',
    component: () => import('@/components/Main/Enrollment.vue'),
    // beforeEnter: (to: Route, from: Route, next: NavigationGuardNext) => {
    //   if (store.state.paid) {
    //     next({ name: 'success' })
    //     return
    //   }
    //   next()
    // },
    props: { rulesFromProps: [rules.maxAge.bind(19), rules.minAge.bind(8)] },
  },
  { path: '/placement', component: Placement, name: 'Placement' },
  {
    name: 'summer_success',
    path: '/summer-payment-confirmation',
    component: SummerPaymentConfirmation,
  },
  {
    name: 'intro_success',
    path: '/payment-confirmation-intro',
    component: PaymentConfirmation,
    props: { enrollType: 'intro' },
  },
  { path: '/summer', redirect: '/' },
  { path: '/', redirect: '/join' },
]

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes,
})

export default router
